var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var SmdPadstackData = require("./smdPadstackData.js");
var RectangleData = require('../svg/rectangleData.js');

var ThermalPadstackData = function (topCopper, maskEnable, maskOverride, pasteEnable, pasteOverride, pasteStencilApertureGapX, pasteStencilApertureGapY, pasteStencilApertureLength, pasteStencilApertureWidth, pasteStencilRowCount, pasteStencilColCount) {
    SmdPadstackData.call(this, topCopper, maskEnable, maskOverride, undefined, pasteEnable, pasteOverride, undefined);
    
    this.pasteStencilApertureGapX = this.value("pasteStencilApertureGapX", true);
    this.pasteStencilApertureGapY = this.value("pasteStencilApertureGapY", true);
    this.pasteStencilApertureLength = this.value("pasteStencilApertureLength", true);
    this.pasteStencilApertureWidth = this.value("pasteStencilApertureWidth", true);
    this.pasteStencilRowCount = this.value("pasteStencilRowCount", true);
    this.pasteStencilColCount = this.value("pasteStencilColCount", true);

    if(pasteStencilApertureGapX != undefined) this.pasteStencilApertureGapX(pasteStencilApertureGapX);
    if(pasteStencilApertureGapY != undefined) this.pasteStencilApertureGapY(pasteStencilApertureGapY);
    if(pasteStencilApertureLength != undefined) this.pasteStencilApertureLength(pasteStencilApertureLength);
    if(pasteStencilApertureWidth != undefined) this.pasteStencilApertureWidth(pasteStencilApertureWidth);
    if(pasteStencilRowCount != undefined) this.pasteStencilRowCount(pasteStencilRowCount);
    if(pasteStencilColCount != undefined) this.pasteStencilColCount(pasteStencilColCount);
};

lib_core.inherit(ThermalPadstackData, SmdPadstackData);
lib_core.JsonParser.registerClass(ThermalPadstackData, "ThermalPadstackData");

module.exports = ThermalPadstackData;

ThermalPadstackData.prototype.getSolderPaste = function() {
    var topCopper = this.topCopper().clone();

    if(this.pasteEnable()) {
        if(!this.pasteOverride()) {
            return SmdPadstackData.prototype.getSolderPaste.call(this);
        } else {
            var apertures = [];
            
            //the notion of length (along x-dir) is width and width (along y-dir) is height in shape data
            var padLength = topCopper.width();
            var padWidth = topCopper.height();
            
            var nRow = this.pasteStencilRowCount();
            var nCol = this.pasteStencilColCount();
            var apertureLength = this.pasteStencilApertureLength();
            var apertureWidth = this.pasteStencilApertureWidth();
            var apertureGapX = this.pasteStencilApertureGapX();
            var apertureGapY = this.pasteStencilApertureGapY();

            var offsetFromPadLeftEdge = (padLength - nCol * apertureLength - (nCol - 1) * apertureGapX) / 2;
            var offsetFromPadTopEdge = (padWidth - nRow * apertureWidth - (nRow - 1) * apertureGapY) / 2;

            for(var i = 0; i < nRow; i++) {
                for(var j = 0; j < nCol; j++) {
                    var sx = -padLength / 2 + offsetFromPadLeftEdge;
                    var sy = -padWidth / 2 + offsetFromPadTopEdge;

                    var cx = sx + j * (apertureLength + apertureGapX) + apertureLength / 2;
                    var cy = sy + i * (apertureWidth + apertureGapY) + apertureWidth / 2;

                    var shape = new RectangleData(new lib_geometry.Coord(cx, cy), 0, apertureLength, apertureWidth, true, 0);
                    apertures.push(shape);
                }
            }

            return apertures;
        }
    } else {
        return null;
    }
};
